import React from 'react';
import styles from './Dot.module.scss'

export const Dot = (props) => {
  return (
    <div className={styles.container}>
      <span >&nbsp;</span>
      {props.children}
    </div>
  );
};

export default React.memo(Dot);